module.exports = __webpack_public_path__ + "img/home_xietong.e5498a91.png";